import axios from 'axios'

export default ({
    namespaced: true,
    state: {
        users: null,
    },
    
    getters:{
        users(state){
            return state.users
        },
    },

    mutations: {
        SET_USERS(state, data) {
            state.users = data
        },
    },

    actions: {
        async deleteUser({dispatch}, id) {
            try {
                let response = await axios.delete(`user/${id}`)
                dispatch('auth/setAuthMessage', response.data.message, { root: true })
                return dispatch('getUsers')
            } catch (e) {
                dispatch('auth/setAuthErrors', e.response.data, { root: true })
                throw Error;
            }
        },
        async resetUserPassword({dispatch}, id) {
            try {
                let response = await axios.patch(`user/${id}/password`)
                dispatch('auth/setAuthMessage', response.data.message, { root: true })
            } catch (e) {
                dispatch('auth/setAuthErrors', e.response.data, { root: true })
                throw Error;
            }
        },
        async getUsers({commit,dispatch}, page) {
            try {
                page = page ? page : 0
                let response = await axios.get('users', {
                    params: { page: page}
                })
                let new_obj= {}
                let rev_obj = Object.keys(response.data.data)
                let index = 0
                rev_obj.forEach(function(i) { 
                    new_obj[index] = response.data.data[i]
                    index++
                })
                response.data.data = new_obj
                commit('SET_USERS', response.data)
               
            } catch (e) {
                dispatch('auth/setAuthErrors', e.response.data )
                throw Error;
            }
        },
    }
})
